import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { Stack, TextField, Tooltip, FormHelperText } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import Iconify from "../iconify/Iconify";
import moment from "moment";
import { toDate } from "date-fns";

// ----------------------------------------------------------------------

RHFDatePicker.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFDatePicker({ name, helperText, tooltip, ...other }) {
  const { control } = useFormContext();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            {...other}
            // value={field.value}
            value={
              field.value ? moment(field.value, "YYYY-MM-DD").toDate() : null
            }
            inputFormat="dd-MM-yyyy"
            // onChange={field.onChange}
            onChange={(newValue) => {
              // console.log(newValue);
              console.log(moment(new Date(newValue)).format("YYYY-MM-DD"));
              // console.log(new Date(newValue).toISOString());
              // console.log(moment.utc(newValue).format("YYYY-MM-DD"));
              field.onChange(
                // field.onChange(moment(newValue).toISOString().split("T")[0])
                // moment.utc(newValue).format("YYYY-MM-DD")
                moment(new Date(newValue)).format("YYYY-MM-DD")
              );
              // field.onChange(moment.utc(newValue).format("YYYY-MM-DD"));
            }}
            // onChange={field.onChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                error={!!error}
                helperText={
                  <FormHelperText sx={{ fontSize: 14, margin: 0, padding: 0 }}>
                    {error ? error?.message : helperText}
                  </FormHelperText>
                }
                inputProps={{ ...params.inputProps, readOnly: true }}
              />
            )}
          />
        )}
      />

      {tooltip && (
        <Tooltip title={tooltip}>
          <Iconify icon="eva:info-outline" width={16} sx={{ mx: 0.5 }} />
        </Tooltip>
      )}
    </Stack>
  );
}
